import React from "react";
import { RichText } from "prismic-reactjs";

const HeaderElement = ({ headingLevel, children, id }) => {
	return React.createElement(`h${headingLevel}`, { id: id }, children);
};

const htmlSerializer = function(type, element, content, children, key) {
	if (/^heading\d$/.test(type)) {
		const headingLevel = type.replace(/^heading/, "");
		return (
			<HeaderElement
				headingLevel={headingLevel}
				key={key}
				id={element.id}
			>
				{children}
			</HeaderElement>
		);
	}
	if (type === "hyperlink") {
		// always open pdf docs in a new window
		return React.createElement(
			"a",
			getHrefProps(element.data.url),
			children
		);
	}
	return null;
};

export const getHrefProps = url => {
	const isPdf = /\.pdf$/i.test(url);
	return {
		href: url,
		...(isPdf ? { target: "_blank", rel: "noopener noreferrer" } : {}),
	};
};

export const renderRichText = richText =>
	richText ? (
		<RichText render={richText} htmlSerializer={htmlSerializer} />
	) : null; //eslint-disable-line react/display-name

export const bulkRenderRichText = (data, ignoreKeys = []) => {
	const richTextData = {};
	Object.keys(data)
		.filter(k => !ignoreKeys.includes(k))
		.forEach(k => {
			richTextData[k] = renderRichText(data[k]);
		});
	return richTextData;
};
